import { Button } from "@/components/ui/button";
import { Phone, Mail } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const ContactSection = () => {
  const { language } = useLanguage();
  
  return (
    <section id="contact" className="py-20 bg-primary">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-2xl font-bold text-accent mb-4">
          {language === "en" ? "Quality & Professionalism" : "Laatu & Ammattimaisuus"}
        </h2>
        <h3 className="text-3xl md:text-5xl font-bold text-white mb-8">
          {language === "en" ? "Call us now" : "Soita meille nyt"}
        </h3>
        
        <div className="text-4xl md:text-6xl font-bold text-accent mb-4">
          09 31588300
        </div>
        
        <a 
          href="mailto:24@servicehelsinki.com"
          className="flex items-center justify-center gap-2 text-xl md:text-2xl text-white hover:text-accent transition-colors mb-8"
        >
          <Mail className="h-6 w-6" />
          24@servicehelsinki.com
        </a>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button 
            variant="secondary"
            size="lg" 
            className="text-lg px-8 py-4 bg-accent text-black hover:bg-accent-dark whitespace-nowrap"
            onClick={() => window.open('tel:0931588300', '_self')}
          >
            <Phone className="mr-2 h-5 w-5" />
            {language === "en" ? "Call now" : "Soita nyt"}
          </Button>
          
          <Button 
            variant="success"
            size="lg" 
            className="whitespace-nowrap"
            onClick={() => window.open('https://wa.me/358402401909', '_blank')}
          >
            WhatsApp
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
